export default __webpack_public_path__ + "static/media/214.0ce1de11.jpg";